import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Spinner } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import "./_userManagement.scss"
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';
import UnAssignOrAsssignLeadDetailsModal from './UnAssignOrAsssignLeadDetailsModal';
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";

const ADD_OR_DELETE_LEADS = gql`
        mutation($params:AddOrDeleteLeads) {
            addOrDeleteLeads(params:$params)
        }   
    `;

class LeadManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            assignedTo: "",
            assignedToError: "",
            getLeadsData: [],
            selectedOptionId: "1",
            search: "",
            currentPageStartCount: 0,
            currentPageEndCount: 10,
            loading: 0,
            selectAll: false,
            submitted: false,
            selectLeadData: [],
            employeesData: [],
            loadingSpinner: 0,
            currentStep: 1,
            dataClear: 1,
            submitError: "",
            type: "1",
            unassignedOrAssignedLeads: [],
            deleteCheckboxChecked: false,
            noDateError: "",
            submitMessage: "",
            submitMessageColor: "",

            UnAssignLeadDetailsModal: false,
            fieldsData: []

        };
    };

    componentDidMount() {
        this.reload();
        // Branch comes from the header (NavbarOne) — re-scope when it changes.
        this.offBranchScope = onBranchScopeChange(() => this.reload());
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    reload = () => {
        this.getUnassignedAndAssignedLeads();
        this.getLeadManagementEmployees();
    }

    // Branch ids in scope: the header's selection, narrowed to the branches this
    // employee is authorized for (scopeBranches never widens past globalBranches).
    scopedBranchIds = () => {
        const branches = (this.props.globals && this.props.globals.globalBranches) || [];
        return scopeBranches(branches).map((b) => parseInt(b.id)).filter((id) => !isNaN(id));
    }

    handleInputRadioChange = (val) => {

        if (this.state.getLeadsData.length > 0) {

            console.log("vvvv", val, this.state.getLeadsData[0]);

            if (val == "1") {
                this.setState({ unassignedOrAssignedLeads: this.state.getLeadsData[0].unAssigned_Leads, selectedOptionId: val, type: val, assignedTo: "", assignedToError: "", deleteCheckboxChecked: false, selectAll: false, search: "", submitError: "", selectLeadData: [] })
            } else {
                this.setState({ unassignedOrAssignedLeads: this.state.getLeadsData[0].assigned_Leads, selectedOptionId: val, type: val, assignedTo: "", assignedToError: "", deleteCheckboxChecked: false, selectAll: false, search: "", submitError: "", selectLeadData: [] })
            }
        } else {

            this.setState({ unassignedOrAssignedLeads: [], assignedTo: "", assignedToError: "", })
        }
    };

    getUnassignedAndAssignedLeads = async () => {
        // The service takes a single branch_id, so the header's branch scope is
        // fanned out and the rows concatenated.
        const branchIds = this.scopedBranchIds();
        if (branchIds.length === 0) {
            this.setState({ loading: 0, loader: 0, noDateError: "No Data Available", unassignedOrAssignedLeads: [], getLeadsData: [] })
            return
        }
        this.setState({ loader: 1 })
        const results = await Promise.all(branchIds.map((branch_id) => this.props.client.query({
            query: gql`
              query($institute_id:Int,$branch_id:Int){
                getUnassignedAndAssignedLeads(institute_id:$institute_id,branch_id:$branch_id){
                    unAssigned_Leads {
                        employee_id
                        employee_name
                        lead_name
                        lead_mobile
                        father_name
                        father_contact_no
                        lead_id
                        source_name
                    }
                    assigned_Leads {
                        employee_id
                        employee_name
                        lead_name
                        lead_mobile
                        father_name
                        father_contact_no
                        lead_id
                        source_name
                      }
                    }
                }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id,
            },
            fetchPolicy: 'network-only'
        })))

        // Collapse the per-branch payloads into the single {unAssigned_Leads,
        // assigned_Leads} bucket the rest of this component already expects. Each
        // lead keeps the branch it came from so the details modal can still ask
        // getFormFieldsData for one branch rather than the whole scope.
        const unAssigned_Leads = [];
        const assigned_Leads = [];
        results.forEach((r, i) => {
            const branch_id = branchIds[i];
            (r.data.getUnassignedAndAssignedLeads || []).forEach((row) => {
                unAssigned_Leads.push(...(row.unAssigned_Leads || []).map((l) => ({ ...l, branch_id })));
                assigned_Leads.push(...(row.assigned_Leads || []).map((l) => ({ ...l, branch_id })));
            });
        });

        if (unAssigned_Leads.length > 0 || assigned_Leads.length > 0) {

            let data = [{ unAssigned_Leads, assigned_Leads }]

            let unassignedOrAssignedLeads = data[0].unAssigned_Leads.length > 0 ? data[0].unAssigned_Leads : data[0].assigned_Leads.length > 0 ? data[0].assigned_Leads : [];
            let selectedOptionId = data[0].unAssigned_Leads.length > 0 ? "1" : data[0].assigned_Leads.length > 0 ? "2" : "0";
            let type = data[0].unAssigned_Leads.length > 0 ? "1" : data[0].assigned_Leads.length > 0 ? "2" : "0";



            this.setState({
                getLeadsData: data, loader: 0, submitted: true, unassignedOrAssignedLeads: unassignedOrAssignedLeads, selectedOptionId: selectedOptionId, type: type, submitMessage: "",
                submitMessageColor: "",
                assignedTo: "",
                assignedToError: "",
                selectAll: false,
                deleteCheckboxChecked: false,
                selectLeadData: []
            })

        } else {
            this.setState({
                loading: 0, loader: 0, noDateError: "No Data Available", unassignedOrAssignedLeads: [], getLeadsData: [], submitMessage: "",
                submitMessageColor: "",
                assignedTo: "",
                assignedToError: "",
                selectAll: false,
                deleteCheckboxChecked: false,
                selectLeadData: []
            })
        }
    };

    getLeadManagementEmployees = async () => {
        const branchIds = this.scopedBranchIds();
        if (branchIds.length === 0) { this.setState({ employeesData: [] }); return }
        this.setState({ loader: 1 })
        const employeeResults = await Promise.all(branchIds.map((branch_id) => this.props.client.query({
            query: gql`
              query($institute_id:Int,$branch_id:Int){
                getLeadManagementEmployees(institute_id:$institute_id,branch_id:$branch_id){
                    employee_id
                    assigned_status
                    employee_name
                    emp_mobile                
                    }
                }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id,
            },
            fetchPolicy: 'network-only'
        })))

        // An employee mapped to more than one in-scope branch comes back once per
        // branch — de-dupe so the "Assign To" list has no repeats.
        const seenEmp = new Set();
        const data = [];
        employeeResults.forEach((r) => {
            (r.data.getLeadManagementEmployees || [])
                .filter((a) => a.assigned_status == "assigned")
                .forEach((e) => {
                    const key = String(e.employee_id);
                    if (seenEmp.has(key)) return;
                    seenEmp.add(key);
                    data.push(e);
                });
        });

        this.setState({ employeesData: data })
    };

    assignedToHandle = (e) => {
        let name = e.target.name
        let value = e.target.value
        console.log("value", value)
        if (name == "assigned") {
            this.setState({
                assignedTo: value,
                assignedToError: "",
                currentPageStartCount: 0,
                currentPageEndCount: 10,
            })
        }
    };

    handleSelectAllChange = () => {
        const { unassignedOrAssignedLeads, selectAll } = this.state;
        const updatedLeads = unassignedOrAssignedLeads.map(item => ({
            ...item,
            selected: !selectAll,
        }));

        const updatedSelectLeadData = updatedLeads.filter((lead) => lead.selected);

        this.setState({
            selectAll: !selectAll,
            unassignedOrAssignedLeads: updatedLeads,
            selectLeadData: updatedSelectLeadData,
            submitError: ""
        });
    };

    handleCheckboxChange = (item) => {
        const { unassignedOrAssignedLeads } = this.state;

        const updatedLeads = unassignedOrAssignedLeads.map((lead) => ({
            ...lead,
            selected: lead === item ? !lead.selected : lead.selected,
        }));

        const updatedSelectLeadData = updatedLeads.filter((lead) => lead.selected);
        const allSelected = updatedLeads.every((lead) => lead.selected);
        console.log("allSelected", allSelected);

        this.setState({
            unassignedOrAssignedLeads: updatedLeads,
            selectLeadData: updatedSelectLeadData,
            selectAll: allSelected,
            submitError: "",
        });
    };

    searchFilter = (e) => {
        let value = e.target.value
        console.log("elllllll", value);
        this.setState({ search: value, currentPageStartCount: 0, currentPageEndCount: 10 })
    };

    pageChange = (pageNumber) => {
        console.log("pageNumber", pageNumber);
        this.setState({
            currentPageStartCount: (+pageNumber - 1) * 10,
            currentPageEndCount: +pageNumber * 10
        })
    }

    handleSubmit = () => {

        if (this.state.type == "3") {

            if (this.state.selectLeadData.length == 0) {
                this.setState({ submitError: "Please select at least one lead.", loadingSpinner: 0 });
                return;
            }

            let array = [];
            let employeeArray = [];

            this.state.selectLeadData.map((item) => {
                array.push({ lead_id: item.lead_id });
                employeeArray.push({ employee_id: item.employee_id });
            });

            const params = {
                type: parseInt(this.state.type),
                assigned_emp_id: 0,
                inserted_by: parseInt(Cookies.get("id")),
                lead_detatils: array
            };

            this.setState({
                loadingSpinner: 1
            });

            this.addOrDeleteLeads(params).catch((error) => {
                console.log("catch if error");
                console.log(error);
                this.setState({
                    submitError: error.graphQLErrors.map((x) => x.message),
                    loadingSpinner: 0
                });
                console.error("ERR =>", error.graphQLErrors.map((x) => x.message));
            });
        } else {

            if (this.state.selectLeadData.length == 0) {
                this.setState({ submitError: "Please select at least one lead.", loadingSpinner: 0 });
                return;
            }

            if (this.state.assignedTo == "") {
                this.setState({ assignedToError: "Please Select Assigned Leads To" });
                return "";
            }

            let array = [];

            this.state.selectLeadData.map((item) => {
                array.push({ lead_id: item.lead_id });
            });

            const params = {
                type: parseInt(this.state.type),
                assigned_emp_id: parseInt(this.state.assignedTo),
                inserted_by: parseInt(Cookies.get("id")),
                lead_detatils: array
            };

            console.log("params", params);
            this.setState({
                loadingSpinner: 1
            });

            this.addOrDeleteLeads(params).catch((error) => {
                console.log("catch if error");
                console.log(error);
                this.setState({
                    submitError: error.graphQLErrors.map((x) => x.message),
                    loadingSpinner: 0
                });
                console.error("ERR =>", error.graphQLErrors.map((x) => x.message));
            });
        }
    };

    addOrDeleteLeads = async (
        params) => {
        await this.props.addOrDeleteLeads({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addOrDeleteLeads) {

                    let successMessage = "";
                    let messageColor = "";

                    if (params.type == 1) {
                        successMessage = "Leads Assign Successfully";
                        messageColor = "successColorGreen"
                    } else if (params.type == 2) {
                        successMessage = "Leads Update Successfully";
                        messageColor = "successColorGreen"
                    } else if (params.type == 3) {
                        successMessage = "Leads Unassign Successfully";
                        messageColor = "deleteColorRed"
                    }

                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                        submitMessage: successMessage,
                        submitMessageColor: messageColor
                    })
                    setTimeout(() => {
                        this.setState({ currentStep: 1, submitMessage: "", submitMessageColor: "" });
                        this.getUnassignedAndAssignedLeads();
                    }, 1500)

                }
            }
        });
    };

    handleDeleteCheckboxChange = () => {
        this.setState((prevState) => ({
            deleteCheckboxChecked: !prevState.deleteCheckboxChecked,
            type: prevState.deleteCheckboxChecked ? "1" : "3",
            assignedTo: "",
            assignedToError: "",
            submitError: "",
        }));
    };

    handleGetLeads = (e) => {
        e.preventDefault();
        this.reload();
    }

    getFormFieldsData = async (val, branchId) => {

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int, $branch_id:String, $lead_id:Int! ) {
                getFormFieldsData(institute_id:$institute_id, branch_id:$branch_id, lead_id: $lead_id) {
                    form_fields_id
                    form_field_name
                    lead_id
                    lead_mobile
                    lead_name
                    value
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                // The branch the lead itself came from (tagged during the fan-out),
                // so this stays a single-branch lookup as the service expects.
                branch_id: branchId != null ? String(branchId) : "",
                lead_id: parseInt(val),
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getFormFieldsData.length > 0) {
            let data = result.data.getFormFieldsData;
            this.setState({ fieldsData: data })
        } else {
            this.setState({ fieldsData: [] })
        }
    }

    unAssignOrAssignLeadDetails = (row) => {
        this.getFormFieldsData(row.lead_id, row.branch_id)
        setTimeout(() => {
            this.setState({
                UnAssignLeadDetailsModal: true,
            })
        }, 700)
    };

    render() {
        const { getLeadsData, unassignedOrAssignedLeads, selectedOptionId,
                selectAll, loader, noDateError, deleteCheckboxChecked,
                employeesData, assignedTo, assignedToError,
                loadingSpinner, currentStep, submitMessage, submitMessageColor, submitError } = this.state;

        /* ── columns for CardLessDataTableWithSearch ── */
        const leadsColumns = [
            {
                dataField: 'select',
                text: (
                    <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={this.handleSelectAllChange}
                            style={{ cursor: 'pointer', width: 16, height: 16 }}
                        />
                        <span style={{ fontSize: 12, color: '#64748b' }}>All</span>
                    </div>
                ),
                headerStyle: { width: 70, textAlign: 'center' },
                style: { textAlign: 'center', verticalAlign: 'middle' },
                formatter: (cell, row) => (
                    <input
                        type="checkbox"
                        checked={row.selected || false}
                        onChange={() => this.handleCheckboxChange(row)}
                        style={{ cursor: 'pointer', width: 16, height: 16 }}
                    />
                ),
            },
            {
                dataField: 'lead_name',
                text: 'Lead Name',
                sort: true,
                formatter: (cell, row) => (
                    <a
                        href="#"
                        style={{ color: '#6366f1', fontWeight: 600 }}
                        onClick={(e) => { e.preventDefault(); this.unAssignOrAssignLeadDetails(row); }}
                    >
                        {cell || '-'}
                    </a>
                ),
            },
            { dataField: 'lead_mobile', text: 'Mobile', sort: true },
            { dataField: 'source_name', text: 'Source', sort: true },
            ...(selectedOptionId === '2'
                ? [{ dataField: 'employee_name', text: 'Assigned Employee', sort: true }]
                : []),
        ];

        const FIN = {
            card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
            cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
            iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
            cardTitleText: { display: "flex", flexDirection: "column", textAlign: "left" },
            cardTitle: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
            cardSubtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
            label: { fontWeight: 600, fontSize: 13, color: "#475569", marginBottom: 6 },
            input: { borderRadius: 9, border: "1px solid #e2e8f0", padding: "9px 12px", fontSize: 13, height: 42, color: "#0f172a" },
            btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
            btnDanger: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#ef4444", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
        };

        return (
            <section>
                <Container fluid>
                    <Row>
                        <Col xl={12} className="mt-2">
                            {/* ── Filter bar ── */}
                            <Card style={{ ...FIN.card, marginBottom: 20 }}>
                                <div style={FIN.cardHeader}>
                                    <div style={FIN.iconWrapper}><i className="fal fa-funnel-dollar" /></div>
                                    <div style={FIN.cardTitleText}>
                                        <h6 style={FIN.cardTitle}>Lead Management</h6>
                                        <span style={FIN.cardSubtitle}>Assign or unassign leads to employees</span>
                                    </div>
                                </div>
                                <Card.Body style={{ padding: '20px 24px' }}>
                                    <Form>
                                        <Form.Row className="align-items-end">
                                            {/* No Branch filter — the header's branch selection scopes these leads. */}

                                            <Form.Group as={Col} lg={2} md={4} sm={12} className="mb-0">
                                                <button
                                                    className="mt-4"
                                                    style={FIN.btnPrimary}
                                                    onClick={this.handleGetLeads}
                                                >
                                                    Get Leads
                                                </button>
                                            </Form.Group>

                                            {getLeadsData.length > 0 && (
                                                <Col lg={7} md={12} sm={12} className="d-flex justify-content-end align-items-center mt-2 mt-lg-4">
                                                    {getLeadsData[0].unAssigned_Leads.length > 0 && (
                                                        <Form.Check
                                                            type="radio"
                                                            name="radioOption"
                                                            id="radio-unassign"
                                                            label="Unassigned Leads"
                                                            className="mr-4"
                                                            onClick={() => this.handleInputRadioChange('1')}
                                                            checked={selectedOptionId === '1'}
                                                            style={{ cursor: 'pointer', fontWeight: 600, fontSize: 13 }}
                                                        />
                                                    )}
                                                    {getLeadsData[0].assigned_Leads.length > 0 && (
                                                        <Form.Check
                                                            type="radio"
                                                            name="radioOption"
                                                            id="radio-assign"
                                                            label="Assigned Leads"
                                                            onClick={() => this.handleInputRadioChange('2')}
                                                            checked={selectedOptionId === '2'}
                                                            style={{ cursor: 'pointer', fontWeight: 600, fontSize: 13 }}
                                                        />
                                                    )}
                                                </Col>
                                            )}
                                        </Form.Row>
                                    </Form>
                                </Card.Body>
                            </Card>

                            {/* ── Loader ── */}
                            {loader === 1 && (
                                <div className="d-flex justify-content-center my-4">
                                    <div className="spinner-border text-primary" />
                                </div>
                            )}

                            {/* ── No data message ── */}
                            {loader !== 1 && getLeadsData.length === 0 && noDateError !== '' && (
                                <div className="text-center text-muted py-4">{noDateError}</div>
                            )}

                            {/* ── Leads table ── */}
                            {loader !== 1 && getLeadsData.length > 0 && (
                                <Card style={FIN.card}>
                                    <Card.Body>
                                        <CardLessDataTableWithSearch
                                            parentData={unassignedOrAssignedLeads}
                                            particlecolumns={leadsColumns}
                                            name="leads"
                                        />

                                        {/* ── Actions row ── */}
                                        {unassignedOrAssignedLeads.length > 0 && (
                                            <Row className="mt-3 align-items-center">
                                                {selectedOptionId === '2' && (
                                                    <Col lg={3} md={6} sm={12} className="d-flex align-items-center">
                                                        <input
                                                            type="checkbox"
                                                            id="deleteCheckbox"
                                                            checked={deleteCheckboxChecked}
                                                            onChange={this.handleDeleteCheckboxChange}
                                                            style={{ width: 18, height: 18, cursor: 'pointer', marginRight: 8 }}
                                                        />
                                                        <label htmlFor="deleteCheckbox" style={{ cursor: 'pointer', fontWeight: 600, fontSize: 13, margin: 0, color: '#ef4444' }}>
                                                            Un-Assign Selected
                                                        </label>
                                                    </Col>
                                                )}

                                                {!deleteCheckboxChecked && (
                                                    <Col lg={4} md={6} sm={12}>
                                                        <Form.Label style={FIN.label}>Assign To</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            name="assigned"
                                                            onChange={this.assignedToHandle}
                                                            value={assignedTo}
                                                            style={FIN.input}
                                                        >
                                                            <option value="">Select Employee</option>
                                                            {employeesData.map((emp) => (
                                                                <option key={emp.employee_id} value={emp.employee_id}>{emp.employee_name}</option>
                                                            ))}
                                                        </Form.Control>
                                                        <Form.Text className="text-danger">{assignedToError}</Form.Text>
                                                    </Col>
                                                )}

                                                <Col className="d-flex justify-content-end align-items-center" style={{ gap: 12 }}>
                                                    {currentStep === 5 ? (
                                                        <span className={`font-weight-bold ${submitMessageColor}`} style={{ fontSize: 13 }}>
                                                            {submitMessage}
                                                        </span>
                                                    ) : (
                                                        <span className="text-danger" style={{ fontSize: 13 }}>{submitError}</span>
                                                    )}
                                                    <button
                                                        style={deleteCheckboxChecked ? FIN.btnDanger : FIN.btnPrimary}
                                                        onClick={this.handleSubmit}
                                                    >
                                                        {loadingSpinner === 1 && (
                                                            <span className="spinner-border spinner-border-sm mr-2" />
                                                        )}
                                                        {deleteCheckboxChecked ? 'Un-Assign' : 'Assign'}
                                                    </button>
                                                </Col>
                                            </Row>
                                        )}
                                    </Card.Body>
                                </Card>
                            )}
                        </Col>
                    </Row>
                </Container>

                <UnAssignOrAsssignLeadDetailsModal
                    stateData={this.state}
                    show={this.state.UnAssignLeadDetailsModal}
                    onHide={() => this.setState({ UnAssignLeadDetailsModal: false })}
                />
            </section>
        );
    }
}

export default withRouter(withApollo(compose(
    graphql(ADD_OR_DELETE_LEADS, {
        name: "addOrDeleteLeads"
    }),
)(LeadManagement)));